function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-coverage {\n        fill: currentColor;\n        stroke: currentColor;\n        stroke-width: .2px\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Component_225_1",
  "data-name": "Component 225 \\u2013 1",
  transform: "translate(.1 .1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_9511",
  "data-name": "Path 9511",
  className: "cls-coverage",
  d: "M43.358 44.318a1.285 1.285 0 1 0-.406.066 1.422 1.422 0 0 0 .406-.066z",
  transform: "translate(-36.237 -35.393)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9512",
  "data-name": "Path 9512",
  className: "cls-coverage",
  d: "M19.8 63.669a.362.362 0 0 1 .679-.175 5.015 5.015 0 0 0 8.795.006.362.362 0 0 1 .634.351 5.74 5.74 0 0 1-10.063-.007.362.362 0 0 1-.045-.175z",
  transform: "translate(-18.16 -53.507)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9513",
  "data-name": "Path 9513",
  className: "cls-coverage",
  d: "M29.547 59.089a.362.362 0 0 1 .673-.185 3.234 3.234 0 0 0 2.767 1.576 3.193 3.193 0 0 0 2.763-1.57.362.362 0 1 1 .622.371 3.94 3.94 0 0 1-6.774-.008.358.358 0 0 1-.051-.184z",
  transform: "translate(-26.27 -49.698)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9514",
  "data-name": "Path 9514",
  className: "cls-coverage",
  d: "M29.547 28.68a.358.358 0 0 1 .053-.18 3.94 3.94 0 0 1 6.774-.008.362.362 0 0 1-.622.371 3.193 3.193 0 0 0-2.763-1.57 3.234 3.234 0 0 0-2.767 1.576.362.362 0 0 1-.673-.185z",
  transform: "translate(-26.27 -22.942)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9515",
  "data-name": "Path 9515",
  className: "cls-coverage",
  d: "M19.8 18.947a.362.362 0 0 1 .045-.174 5.74 5.74 0 0 1 10.064-.008.362.362 0 0 1-.634.351 5.015 5.015 0 0 0-8.795.007.362.362 0 0 1-.68-.175z",
  transform: "translate(-18.16 -13.979)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9516",
  "data-name": "Path 9516",
  className: "cls-coverage",
  d: "M10.053 68.248a.362.362 0 0 1 .682-.17 6.819 6.819 0 0 0 12.066.007.362.362 0 1 1 .64.341 7.544 7.544 0 0 1-13.341-.008.358.358 0 0 1-.047-.17z",
  transform: "translate(-10.053 -57.317)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9517",
  "data-name": "Path 9517",
  className: "cls-coverage",
  d: "M19.8 63.669a.362.362 0 0 1 .679-.175 5.015 5.015 0 0 0 8.795.006.362.362 0 0 1 .634.351 5.74 5.74 0 0 1-10.063-.007.362.362 0 0 1-.045-.175z",
  transform: "translate(-18.16 -53.507)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9518",
  "data-name": "Path 9518",
  className: "cls-coverage",
  d: "M19.8 18.947a.362.362 0 0 1 .045-.174 5.74 5.74 0 0 1 10.064-.008.362.362 0 0 1-.634.351 5.015 5.015 0 0 0-8.795.007.362.362 0 0 1-.68-.175z",
  transform: "translate(-18.16 -13.979)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_9519",
  "data-name": "Path 9519",
  className: "cls-coverage",
  d: "M10.053 9.214a.357.357 0 0 1 .043-.17 7.544 7.544 0 0 1 13.346-.007.362.362 0 1 1-.64.341 6.82 6.82 0 0 0-12.066.007.362.362 0 0 1-.682-.17z",
  transform: "translate(-10.053 -5.016)"
}));

function SvgCoverage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.651,
    height: 15.329,
    viewBox: "0 0 13.651 15.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverage);
export default __webpack_public_path__ + "static/media/coverage.13bb548c.svg";
export { ForwardRef as ReactComponent };